import localStorage from './localStorage';
import { APP_CONFIG } from '@/config/app-config';

const authProvider: any = {
    getToken,
    setToken,
    removeToken,
    isToken,
};

export default authProvider;

function getToken() {
    return localStorage.get(APP_CONFIG.authSetting.tokenName);
}

function setToken(data: any) {
    localStorage.set(APP_CONFIG.authSetting.tokenName, data);
}

function removeToken(): any {
    localStorage.remove(APP_CONFIG.authSetting.tokenName);
}

function isToken() {
    return !!localStorage.get(APP_CONFIG.authSetting.tokenName);
}
